import { render, staticRenderFns } from "./AssignDriver.vue?vue&type=template&id=6c7579a3"
import script from "./AssignDriver.vue?vue&type=script&lang=js"
export * from "./AssignDriver.vue?vue&type=script&lang=js"
import style0 from "./AssignDriver.vue?vue&type=style&index=0&id=6c7579a3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports